import { ApiPortfolioType } from '@/api'
import { Icon, IconButton, LinkIcon, Space, TextInput } from '@/components/core-v2'
import { PORTFOLIO_TYPE } from '@/constants'

import { AssetSummaryItem, ModelPortfolio } from '../types'
import { PortfolioFullDetails } from './portfolio-full-details'
import { PortfoliosTable } from './portfolios-table'

export type PortfolioResult = {
  id: string
  name: string
  portfolioType?: ApiPortfolioType
  taxClassification: string
}

export type PortfolioFinderProps = {
  allAssetPerformance: Record<string, AssetSummaryItem[]>
  onChangeSearchTerm: (val: string) => void
  onClickBackToSearch: () => void
  onInspectPorfolio: (val: string) => void
  onSelectPortfolio: (portfolio: ModelPortfolio) => void
  portfolioBeingInspected?: ModelPortfolio
  portfolioType?: ApiPortfolioType
  portfolios: PortfolioResult[]
  searchTerm: string
  status: 'finding' | 'inspecting'
}

export const PortfolioFinder = ({
  allAssetPerformance,
  onChangeSearchTerm,
  onClickBackToSearch,
  onInspectPorfolio,
  onSelectPortfolio,
  portfolioBeingInspected,
  portfolioType,
  portfolios,
  searchTerm,
  status
}: PortfolioFinderProps) => {
  const title = portfolioType
    ? `Search for a ${PORTFOLIO_TYPE[portfolioType].value} portfolio`
    : 'Search for a portfolio'
  if (status === 'finding') {
    return (
      <Space flexGrow={1} mx={5} my={6}>
        <Space mb={6}>
          <TextInput
            placeholder={title}
            value={searchTerm}
            onChange={e => onChangeSearchTerm(e.target.value)}
          />
        </Space>
        <PortfoliosTable
          portfolioType={portfolioType}
          portfolios={portfolios}
          onClickPortfolio={id => onInspectPorfolio(id)}
        />
      </Space>
    )
  }

  if (status === 'inspecting') {
    return (
      <Space isflex flexDirection="column">
        <Space flexGrow={1} p={0}>
          <PortfolioFullDetails
            allAssetPerformance={allAssetPerformance}
            portfolio={portfolioBeingInspected}
          />
        </Space>

        <Space isflex alignItems="center" justifyContent="space-between" p={5}>
          <LinkIcon
            disabled={false}
            icon={<Icon name="chevronLeft" size="small" />}
            iconPosition="left"
            text="Back to search"
            onClick={() => onClickBackToSearch()}
          />
          <IconButton
            data-testid="btn-choose"
            disabled={false}
            icon={<Icon name="chevronRight" size="small" />}
            iconPosition="right"
            operationType="progress"
            text="Choose"
            onClick={() => onSelectPortfolio(portfolioBeingInspected)}
          />
        </Space>
      </Space>
    )
  }
}
